export default "__VITE_ASSET__4c6b1edb__"